export default "__VITE_ASSET__FUmRQRqc__"